export default __webpack_public_path__ + "static/media/icon_organization.e7f44737.svg";